import { MontaProduct } from '@domain/connection/models/MontaProduct';

export class MockMontaDataSource {
  /**
   * Generate mock Monta products with realistic data structure
   */
  static generateMockProducts(): MontaProduct[] {
    return [
      {
        Product: {
          Sku: "IPH15PM-256-NT",
          Description: "iPhone 15 Pro Max - 256GB - Natural Titanium",
          Barcodes: ["1234567890123", "9876543210987"],
          WeightGrammes: null,
          LengthMm: null,
          WidthMm: null,
          HeightMm: null,
          Stock: {
            StockInboundForecasted: 50,
            StockQuarantaine: 2,
            StockAll: 1250,
            StockBlocked: 15,
            StockInTransit: 75,
            StockReserved: 45,
            StockInboundHistory: 200,
            StockAvailable: 1150,
            StockWholeSaler: 800,
            StockOpen: 350,
            MaxPhysicalStock: 2000,
            MinPhysicalStock: 100,
            PerWarehouse: [
              {
                Warehouse: {
                  Guid: "warehouse-1",
                  Name: "Amsterdam Main Warehouse",
                  OwnedByYou: true
                },
                StockQuarantaine: 1,
                StockAll: 800,
                StockBlocked: 10,
                StockInTransit: 50,
                StockReserved: 30,
                StockAvailable: 750,
                StockOpen: 200,
                MaxPhysicalStock: 1200,
                MinPhysicalStock: 80
              },
              {
                Warehouse: {
                  Guid: "warehouse-2",
                  Name: "Rotterdam Distribution Center",
                  OwnedByYou: true
                },
                StockQuarantaine: 1,
                StockAll: 450,
                StockBlocked: 5,
                StockInTransit: 25,
                StockReserved: 15,
                StockAvailable: 400,
                StockOpen: 150,
                MaxPhysicalStock: 800,
                MinPhysicalStock: 20
              }
            ],
            PerLocation: [
              {
                LocationId: 1,
                LocationCode: "LOC-001",
                WarehouseId: 1,
                StockAll: 300,
                StockQuarantaine: 0,
                StockBlocked: 5,
                StockInTransit: 10,
                StockInPicking: 25,
                MaxPhysicalStock: 500,
                MinPhysicalStock: 50
              },
              {
                LocationId: 2,
                LocationCode: "LOC-002",
                WarehouseId: 1,
                StockAll: 200,
                StockQuarantaine: 1,
                StockBlocked: 3,
                StockInTransit: 8,
                StockInPicking: 15,
                MaxPhysicalStock: 300,
                MinPhysicalStock: 30
              }
            ],
            Batches: [
              {
                Reference: "BATCH-2024-001",
                Quantity: 500,
                BestBeforeDate: "2025-12-31",
                StockAll: 500,
                StockQuarantaine: 0,
                StockBlocked: 20,
                StockInTransit: 0,
                StockReserved: 0,
                StockAvailble: 480,
                StockInWarehouse: 480
              }
            ]
          },
          SupplierCode: null,
          PurchasePrice: null,
          SellingPrice: null,
          PurchasePriceHidden: null,
          Food: false,
          MinimumExpiryPeriodInbound: null,
          MinimumExpiryPeriodOutbound: null,
          Cool: false,
          Note: null,
          HStariefCode: null,
          CountryOfOrigin: null,
          PurchaseStepQty: null,
          RegisterSerialNumber: false,
          RegisterSerialNumberB2B: false,
          IsFragile: false,
          IsDangerous: false,
          SupplierProductCode: null,
          MinimumStock: 0,
          HSCode: null,
          WareHouseProductSettings: null,
          ProductId: null,
          HTSCode: null,
          CustomField1: null,
          ExcludeFromStockForecast: null,
          BatchNonFood: null,
          ProductBarcodes: [
            {
              Barcode: "1234567890123",
              Quantity: 1,
              TypeId: 1
            },
            {
              Barcode: "9876543210987",
              Quantity: 1,
              TypeId: 2
            }
          ],
          LeadTime: null
        }
      },
      {
        Product: {
          Sku: "SGS24U-512-TG",
          Description: "Samsung Galaxy S24 Ultra - 512GB - Titanium Gray",
          Barcodes: ["2345678901234", "8765432109876"],
          WeightGrammes: null,
          LengthMm: null,
          WidthMm: null,
          HeightMm: null,
          Stock: {
            StockInboundForecasted: 30,
            StockQuarantaine: 1,
            StockAll: 850,
            StockBlocked: 8,
            StockInTransit: 45,
            StockReserved: 25,
            StockInboundHistory: 150,
            StockAvailable: 800,
            StockWholeSaler: 600,
            StockOpen: 200,
            MaxPhysicalStock: 1500,
            MinPhysicalStock: 75,
            PerWarehouse: [
              {
                Warehouse: {
                  Guid: "warehouse-1",
                  Name: "Amsterdam Main Warehouse",
                  OwnedByYou: true
                },
                StockQuarantaine: 1,
                StockAll: 550,
                StockBlocked: 5,
                StockInTransit: 30,
                StockReserved: 20,
                StockAvailable: 520,
                StockOpen: 150,
                MaxPhysicalStock: 800,
                MinPhysicalStock: 50
              },
              {
                Warehouse: {
                  Guid: "warehouse-2",
                  Name: "Rotterdam Distribution Center",
                  OwnedByYou: true
                },
                StockQuarantaine: 0,
                StockAll: 300,
                StockBlocked: 3,
                StockInTransit: 15,
                StockReserved: 5,
                StockAvailable: 280,
                StockOpen: 50,
                MaxPhysicalStock: 700,
                MinPhysicalStock: 25
              }
            ],
            PerLocation: [
              {
                LocationId: 1,
                LocationCode: "LOC-001",
                WarehouseId: 1,
                StockAll: 200,
                StockQuarantaine: 0,
                StockBlocked: 3,
                StockInTransit: 8,
                StockInPicking: 12,
                MaxPhysicalStock: 300,
                MinPhysicalStock: 40
              },
              {
                LocationId: 2,
                LocationCode: "LOC-002",
                WarehouseId: 1,
                StockAll: 150,
                StockQuarantaine: 1,
                StockBlocked: 2,
                StockInTransit: 5,
                StockInPicking: 8,
                MaxPhysicalStock: 250,
                MinPhysicalStock: 20
              }
            ],
            Batches: [
              {
                Reference: "BATCH-2024-002",
                Quantity: 300,
                BestBeforeDate: "2025-10-15",
                StockAll: 300,
                StockQuarantaine: 0,
                StockBlocked: 15,
                StockInTransit: 0,
                StockReserved: 0,
                StockAvailble: 285,
                StockInWarehouse: 285
              }
            ]
          },
          SupplierCode: null,
          PurchasePrice: null,
          SellingPrice: null,
          PurchasePriceHidden: null,
          Food: false,
          MinimumExpiryPeriodInbound: null,
          MinimumExpiryPeriodOutbound: null,
          Cool: false,
          Note: null,
          HStariefCode: null,
          CountryOfOrigin: null,
          PurchaseStepQty: null,
          RegisterSerialNumber: false,
          RegisterSerialNumberB2B: false,
          IsFragile: false,
          IsDangerous: false,
          SupplierProductCode: null,
          MinimumStock: 0,
          HSCode: null,
          WareHouseProductSettings: null,
          ProductId: null,
          HTSCode: null,
          CustomField1: null,
          ExcludeFromStockForecast: null,
          BatchNonFood: null,
          ProductBarcodes: [
            {
              Barcode: "2345678901234",
              Quantity: 1,
              TypeId: 1
            },
            {
              Barcode: "8765432109876",
              Quantity: 1,
              TypeId: 2
            }
          ],
          LeadTime: null
        }
      },
      {
        Product: {
          Sku: "MBP16-M3P-1TB",
          Description: "MacBook Pro 16-inch - M3 Pro - 1TB SSD",
          Barcodes: ["3456789012345", "7654321098765"],
          WeightGrammes: null,
          LengthMm: null,
          WidthMm: null,
          HeightMm: null,
          Stock: {
            StockInboundForecasted: 20,
            StockQuarantaine: 0,
            StockAll: 400,
            StockBlocked: 5,
            StockInTransit: 25,
            StockReserved: 15,
            StockInboundHistory: 100,
            StockAvailable: 375,
            StockWholeSaler: 300,
            StockOpen: 75,
            MaxPhysicalStock: 800,
            MinPhysicalStock: 50,
            PerWarehouse: [
              {
                Warehouse: {
                  Guid: "warehouse-1",
                  Name: "Amsterdam Main Warehouse",
                  OwnedByYou: true
                },
                StockQuarantaine: 0,
                StockAll: 250,
                StockBlocked: 3,
                StockInTransit: 15,
                StockReserved: 10,
                StockAvailable: 235,
                StockOpen: 50,
                MaxPhysicalStock: 400,
                MinPhysicalStock: 30
              },
              {
                Warehouse: {
                  Guid: "warehouse-2",
                  Name: "Rotterdam Distribution Center",
                  OwnedByYou: true
                },
                StockQuarantaine: 0,
                StockAll: 150,
                StockBlocked: 2,
                StockInTransit: 10,
                StockReserved: 5,
                StockAvailable: 140,
                StockOpen: 25,
                MaxPhysicalStock: 400,
                MinPhysicalStock: 20
              }
            ],
            PerLocation: [
              {
                LocationId: 1,
                LocationCode: "LOC-001",
                WarehouseId: 1,
                StockAll: 120,
                StockQuarantaine: 0,
                StockBlocked: 2,
                StockInTransit: 5,
                StockInPicking: 8,
                MaxPhysicalStock: 200,
                MinPhysicalStock: 25
              },
              {
                LocationId: 2,
                LocationCode: "LOC-002",
                WarehouseId: 1,
                StockAll: 80,
                StockQuarantaine: 0,
                StockBlocked: 1,
                StockInTransit: 3,
                StockInPicking: 5,
                MaxPhysicalStock: 150,
                MinPhysicalStock: 15
              }
            ],
            Batches: [
              {
                Reference: "BATCH-2024-003",
                Quantity: 200,
                BestBeforeDate: "2026-06-30",
                StockAll: 200,
                StockQuarantaine: 0,
                StockBlocked: 5,
                StockInTransit: 0,
                StockReserved: 0,
                StockAvailble: 195,
                StockInWarehouse: 195
              }
            ]
          },
          SupplierCode: null,
          PurchasePrice: null,
          SellingPrice: null,
          PurchasePriceHidden: null,
          Food: false,
          MinimumExpiryPeriodInbound: null,
          MinimumExpiryPeriodOutbound: null,
          Cool: false,
          Note: null,
          HStariefCode: null,
          CountryOfOrigin: null,
          PurchaseStepQty: null,
          RegisterSerialNumber: false,
          RegisterSerialNumberB2B: false,
          IsFragile: false,
          IsDangerous: false,
          SupplierProductCode: null,
          MinimumStock: 0,
          HSCode: null,
          WareHouseProductSettings: null,
          ProductId: null,
          HTSCode: null,
          CustomField1: null,
          ExcludeFromStockForecast: null,
          BatchNonFood: null,
          ProductBarcodes: [
            {
              Barcode: "3456789012345",
              Quantity: 1,
              TypeId: 1
            },
            {
              Barcode: "7654321098765",
              Quantity: 1,
              TypeId: 2
            }
          ],
          LeadTime: null
        }
      }
    ];
  }

  /**
   * Generate mock warehouses
   */
  static generateMockWarehouses(): { id: string; name: string }[] {
    return [
      { id: "warehouse-1", name: "Amsterdam Main Warehouse" },
      { id: "warehouse-2", name: "Rotterdam Distribution Center" }
    ];
  }

  /**
   * Generate mock locations
   */
  static generateMockLocations(): { id: string; name: string }[] {
    return [
      { id: "LOC-001", name: "Location 001 - Main Storage" },
      { id: "LOC-002", name: "Location 002 - Picking Area" }
    ];
  }

  /**
   * Simulate API delay
   */
  static async delay(ms: number = 500): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * Mock fetch products with realistic delay
   */
  static async fetchProducts(connectionId: string): Promise<{ status: 'success' | 'error'; data?: MontaProduct[]; error?: { message: string } }> {
    await this.delay(800); // Simulate network delay
    
    if (!connectionId) {
      return {
        status: 'error',
        error: { message: 'Connection ID is required' }
      };
    }

    return {
      status: 'success',
      data: this.generateMockProducts()
    };
  }

  /**
   * Mock fetch warehouses
   */
  static async fetchWarehouses(connectionId: string): Promise<{ status: 'success' | 'error'; data?: { id: string; name: string }[]; error?: { message: string } }> {
    await this.delay(300);
    
    return {
      status: 'success',
      data: this.generateMockWarehouses()
    };
  }

  /**
   * Mock fetch locations
   */
  static async fetchLocations(connectionId: string): Promise<{ status: 'success' | 'error'; data?: { id: string; name: string }[]; error?: { message: string } }> {
    await this.delay(300);
    
    return {
      status: 'success',
      data: this.generateMockLocations()
    };
  }
} 